import Handsontable from "handsontable";
import {dRenderer, hotInfiniteScrollRenderer, hotDateRenderer, guid, deepCopy} from "../lib/utils";
import {Model} from "./api/model";
import {PaginationDataSource} from './api/pagination-data-source';

export class HotInstance {
    instance: Handsontable;
    window_height = window.innerHeight - 240;
    resource: Model;
    change_ids: string[];
    new_rows: number[];
    handson_id: string;
    save: () => { deferreds: Promise<any>[]; data: any; savePromises: Promise<any>[]; errors: any; };
    query_handler: (pageNumber: number, pageSize?: number, filters?: object[]) => Promise<any[]>;
    settings: any;
    ready: Boolean;
    never_searched: Boolean;
    original_data: any[];
    source_data: any[];
    column_list: any[];
    account: any; //This is not the site Active Account, this is the "filter table by" account

    last_visible_row: number = -1;
    page_size: number;
    current_page: number = 0;
    query_lookup: { attributes: string[], relationships: { [relationship: string]: string[] } };
    active_filters: object;
    dataSource: PaginationDataSource<any>;
    private requestSeq: number = 0;
    querying: boolean = false;
    replacementLoading: boolean = false;
    private hasMorePages: boolean = true;
    private queryGeneration: number = 0;
    private queryRequestId: number = 0;
    private readOnlyBeforeReplacement: boolean = false;
    rowsShown: number;

    // TODO series component, process access, schedule have different required_keys, set them when invoked

    constructor(public required_keys: string[] = ["attributes.name"]) {
        this.handson_id = guid();
        // @ts-ignore
        Handsontable.renderers.registerRenderer('date_formatter', dRenderer);
        // @ts-ignore
        Handsontable.renderers.registerRenderer('infinite_scroller', hotInfiniteScrollRenderer);
        // @ts-ignore
        Handsontable.renderers.registerRenderer('hot_date_renderer', hotDateRenderer);

    }

    onResize(event) {
        const ctrl = this;
        if (ctrl.ready) {
            ctrl.window_height = window.innerHeight - 240;

            ctrl.instance.render();
            // ctrl.instance.render();
        }
    }

    toCSVString() {
        const instance = this.instance;
        const headers = instance.getColHeader();

        let csv = ""; //"sep=;\n"
        //@ts-ignore
        csv += headers.join(",") + "\n";

        for (let i = 0; i < instance.countRows(); i++) {
            const nameValue = instance.getDataAtRowProp(i, this.required_keys[0]);
            if (nameValue === null || nameValue === undefined || String(nameValue).trim() === '') {
                continue;
            }

            const row = [];
            //@ts-ignore
            for (let h in headers) {
                //@ts-ignore
                const prop = instance.colToProp(h);
                //@ts-ignore
                const value = instance.getDataAtRowProp(i, prop);
                row.push(value)
            }

            csv += row.join(",");
            csv += "\n";
        }

        return csv;
    }

    download(filename?) {
        const csv = this.toCSVString();
        if (filename == null) {
            filename = 'wire.csv'
        }
        const link = document.createElement("a");
        link.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(csv));
        link.setAttribute("download", filename);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link)
    }

    clear() {
        const hotInstance = this;
        this.rowsShown = null;

        if (hotInstance.query_lookup && hotInstance.active_filters) {
            delete hotInstance.active_filters;
            hotInstance.source_data = [];
            hotInstance.current_page = 0;
            hotInstance.query(hotInstance.current_page);
            return;
        }

        if (!hotInstance.never_searched) {
            hotInstance.instance.loadData(hotInstance.original_data);
            if (this.account) {
                this.filter_account(this.account);
            }
            hotInstance.instance.render();
            hotInstance.instance.render();
        }
    }

    filter(search) {
        const hotInstance = this;

        if (hotInstance.query_lookup) {
            return hotInstance.queryFilter(search);
        }

        if (hotInstance.never_searched) {
            hotInstance.original_data = deepCopy(hotInstance.instance.getSourceData())
        }
        hotInstance.never_searched = false;

        const countSourceRows = hotInstance.instance.countSourceRows() - hotInstance.settings.minSpareRows - 1;
        const hidden_rows = [];
        const show_rows = [];
        const show_data = [];
        for (let row = 0; row <= countSourceRows; row++) {
            let hide_row = true;
            for (let col = 0; col <= hotInstance.column_list.length; col++) {
                const val = hotInstance.instance.getSourceDataAtCell(row, col);
                if (('' + val).toLowerCase().indexOf(search.toLowerCase()) > -1) {
                    hide_row = false;
                }
            }

            if (hide_row) {
                hidden_rows.push(row)
            } else {
                show_rows.push(row);
                show_data.push(hotInstance.instance.getSourceDataAtRow(row))
            }

        }
        this.rowsShown = show_data.filter(row => row?.id).length;
        hotInstance.instance.loadData(show_data);
        hotInstance.instance.render();
        hotInstance.instance.render();
    }

    filter_account(account) {
        const ctrl = this;
        ctrl.account = account;

        if (ctrl.query_lookup) {
            ctrl.current_page = 0;
            ctrl.source_data = [];
            return ctrl.query(ctrl.current_page);
        }

        if (!account) {
            this.clear();
            return;
        }

        if (ctrl.never_searched) {
            ctrl.original_data = deepCopy(ctrl.instance.getSourceData());
        }
        ctrl.never_searched = false;

        ctrl.instance.loadData(ctrl.original_data);
        const countSourceRows = ctrl.instance.countSourceRows() - ctrl.settings.minSpareRows - 1;
        const hidden_rows = [];
        const show_rows = [];
        const show_data = [];
        for (let row = 0; row <= countSourceRows; row++) {
            let hide_row = true;
            const val = ctrl.instance.getSourceDataAtRow(row);
            if (val['attributes'] && val['attributes'].account_name && val['attributes'].account_name === account.attributes.name) {
                hide_row = false;
            } else {
                hide_row = true;
            }

            if (hide_row) {
                hidden_rows.push(row)
            } else {
                show_rows.push(row);
                show_data.push(ctrl.instance.getSourceDataAtRow(row))
            }
        }

        this.rowsShown = show_data.filter(row => row?.id).length;
        ctrl.instance.loadData(show_data);
        ctrl.instance.render();
        ctrl.instance.render();
    }

    queryFilter(search) {
        // TODO: implement column-specific filtering
        const ctrl = this;
        if (search) {
            ctrl.current_page = 0;
            const filters = [];
            for (const attr of ctrl.query_lookup.attributes) {
                filters.push({name: attr, op: 'ilike', val: `%${search}%`});
            }
            for (const [relationship, fields] of Object.entries(ctrl.query_lookup.relationships)) {
                const sub_filters = [];
                for (const field of fields) {
                    sub_filters.push({name: field, op: 'ilike', val: `%${search}%`});
                }
                if (sub_filters.length > 1) {
                    filters.push({name: relationship, op: 'has', val: {or: sub_filters}});
                } else {
                    filters.push({name: relationship, op: 'has', val: sub_filters[0]});
                }
            }
            ctrl.active_filters = {or: filters};
            ctrl.source_data = [];
            ctrl.query(ctrl.current_page);
            return;
        }

        ctrl.clear();
    }

     buildFilters(): object[] {
        const filters = [];
        if (this.account) {
            filters.push({
                name: 'account', op: 'has', val: {
                    name: 'name', op: 'eq', val: this.account.attributes.name
                }
            });
        }
        if (this.active_filters) {
            filters.push(this.active_filters);
        }
        return filters;
    }

    query(page) {
        const seq = ++this.requestSeq;
        const filters = this.buildFilters();

        const isAppend = page > 0;
        if (!isAppend) {
            // Blank the grid only on the FIRST load (no instance yet): templates that
            // gate on hot.ready (handson-sheet.template.html) then show their loading
            // state until data arrives. On a REPLACEMENT query against an existing
            // instance (account-filter / search), keep ready=true — otherwise Angular
            // destroys and remounts the search + account-filter controls in
            // handson-sheet.template.html mid-query, and account-filter remounts with
            // its default account, desyncing it from the still-active hot.account
            // filter. getNextPage stays gated by `querying` below, so leaving
            // ready=true here cannot let scroll-append fire during the replacement.
            if (!this.instance) {
                this.ready = false;
            }
            this.queryGeneration += 1;
            this.last_visible_row = -1;
            this.hasMorePages = true;
            if (!this.replacementLoading) {
                this.readOnlyBeforeReplacement = Boolean(this.settings?.readOnly);
                this.setTableReadOnly(true);
            }
            this.replacementLoading = true;
        }
        const generation = this.queryGeneration;
        const requestId = ++this.queryRequestId;
        this.querying = true;

        this.query_handler(page, this.page_size, filters)
            .then(nextData => {
                // Drop stale responses: a newer query has been issued since this one started.
                // `seq` supersedes — every query() bumps requestSeq, so the generation check
                // below is effectively redundant here; it's kept defensively, and
                // queryGeneration independently gates the finally block.
                if (seq !== this.requestSeq) return;
                if (generation !== this.queryGeneration) {
                    return;
                }
                if (page === 0) {
                    this.current_page = page;
                    this.source_data = nextData;
                    this.hasMorePages = this.hasFullPage(nextData);
                } else if (nextData.length) {
                    this.current_page = page;
                    this.source_data = this.source_data.concat(nextData);
                    this.hasMorePages = this.hasFullPage(nextData);
                } else {
                    this.current_page = page;
                    this.hasMorePages = false;
                }
                if (isAppend && nextData.length) {
                    this.appendData(nextData);
                } else if (!isAppend) {
                    this.instance.loadData(deepCopy(this.source_data));
                    this.instance.render();
                }
                this.ready = true;
            })
            .catch(err => {
                // Without this catch, a rejected query_handler leaves `ready=false`
                // forever for replacement loads, and templates gated on hot.ready
                // (handson-sheet.template.html) keep the table tab blank.
                // Callers (e.g. loadNextSeries' finalize) own their own toasts;
                // we just log and let the finally restore UI state.
                if (seq !== this.requestSeq) return;
                if (generation !== this.queryGeneration) return;
                console.error('HotInstance query failed', err);
                this.ready = true;
            })
            .finally(() => {
                if (requestId === this.queryRequestId) {
                    this.querying = false;
                }
                if (!isAppend && generation === this.queryGeneration) {
                    this.replacementLoading = false;
                    this.setTableReadOnly(this.readOnlyBeforeReplacement);
                }
            });
    }

    private hasFullPage(nextData: any[]): boolean {
        return Boolean(this.page_size) && nextData.length >= this.page_size;
    }

    private setTableReadOnly(readOnly: boolean) {
        if (!this.instance) {
            return;
        }
        this.settings.readOnly = readOnly;
        this.instance.updateSettings({readOnly: readOnly}, false);
    }

    private appendData(nextData: any[]) {
        const minSpareRows = this.settings?.minSpareRows || 0;
        const insertAt = Math.max(this.instance.countRows() - minSpareRows, 0);
        this.instance.alter('insert_row', insertAt, nextData.length, 'pagination');
        nextData.forEach((item, index) => {
            const visualRow = insertAt + index;
            const physicalRow = this.instance.toPhysicalRow(visualRow);
            const rowData: any = this.instance.getSourceDataAtRow(
                physicalRow !== null && physicalRow !== undefined ? physicalRow : visualRow
            );
            Object.assign(rowData, deepCopy(item));
        });
        this.instance.render();
    }

    /**
     * Replace the table's data with a fully-loaded dataset (e.g. from
     * collector-mapper's bulk-fetch-for-download path). The active effect is the
     * deepCopy + loadData swap that puts the full set on the grid for the export.
     *
     * The hasMorePages/current_page resets below mark scroll pagination exhausted
     * so a scroll-paginated caller's getNextPage() won't re-request page N+1 for
     * rows already on the grid (without it, downloading 150 rows from a 100-row
     * first page leaves the cursor at its page-0 values and the next vertical
     * scroll appends rows 101-150 a second time). They are inert for the current
     * sole caller — collector-mapper drives paging via mat-paginator, not the
     * scroll hook, and never sets page_size — and kept defensively for any future
     * scroll-paginated caller.
     */
    installFullDataset(rows: any[]): void {
        this.source_data = deepCopy(rows);
        this.instance.loadData(this.source_data);
        this.hasMorePages = false;
        // Advance current_page past the loaded data so getNextPage()'s window
        // check fails immediately (the "(p+1)*pageSize <= length" predicate).
        // Skipped when page_size is unset (no scroll pagination wired).
        if (this.page_size) {
            this.current_page = Math.ceil(this.source_data.length / this.page_size);
        }
    }

    getNextPage() {
        const ctrl = this;
        if (ctrl.ready && !ctrl.querying && ctrl.hasMorePages &&
            (ctrl.current_page + 2) * ctrl.page_size > ctrl.source_data.length &&
            (ctrl.current_page + 1) * ctrl.page_size <= ctrl.source_data.length
        ) {
            const nextPage = ctrl.current_page + 1;
            ctrl.query(nextPage);
        }
    }

    initializeInstance(container) {
        // this saves original data clean of updates from handsontable
        this.source_data = deepCopy(this.settings.data);

        this.instance = new Handsontable(container, this.settings);
    }

    filterPage(search, hot) {
        const ctrl = hot;
        const filters = ctrl.updateSearchFilter(search);
        ctrl.dataSource.filterBy(filters)
    }
}
